import HelpFAQ from './component';

export default HelpFAQ;
